(function () {
    "use strict";

    angular
        .module("app")
        .directive("midsoleSearchHelp", ["SearchFactory", midsoleSearchHelp]);

    function midsoleSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.midsoleKey = "";
                        scope.midsoleName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.midsoleName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.midsoleSearch(scope.sapBrandId, function (midsole) {
                        scope.midsoleKey = midsole ? midsole.MidsoleKey : "";
                        scope.midsoleName = midsole ? midsole.MidsoleName : "";
                        scope.displayValue = scope.midsoleName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("midsoleName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.midsoleName;
                scope.prevDisplayValue = scope.displayValue;
            },
            scope: { midsoleKey: "=", midsoleName: "=", readOnly: "=", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

